import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../components/Login.css";

import { useState } from "react";
import { useBrand } from "../../context/BrandContext";
import defaultAppLogo from "../../assets/smarttt-wordmark.png";
import { resolveClubImageUrl } from "../../utils/resolveClubImageUrl";

export const Landing = () => {
  const { t, i18n } = useTranslation();
  const { brand } = useBrand();
  const [selectedlng, setselectedlng] = useState(
    localStorage.getItem("i18nextLng") || "en"
  );

  const changeLanguage = (e) => {
    const lng = e.target.value;
    setselectedlng(lng);
    localStorage.setItem("lng", lng);
    localStorage.setItem("i18nextLng", lng);
    i18n.changeLanguage(lng);
  };

  const logoSrc = resolveClubImageUrl(brand.logo_url) || defaultAppLogo;
  const brandName = brand.brand_name || "SmartTT Club";

  return (
    <div className="landing-container">
      {/* Simple Header */}
      <div className="landing-header">
        <div className="header-content">
          <div className="logo-container">
            <img src={logoSrc} alt={brandName} className="header-logo" />
          </div>
          <div className="language-selector">
            <select
              value={selectedlng}
              onChange={changeLanguage}
              className="lang-select"
            >
              <option value="en">🇺🇸 {t("language_english")}</option>
              <option value="fr">🇫🇷 {t("language_french")}</option>
              <option value="de">🇩🇪 {t("language_german")}</option>
              <option value="es">🇪🇸 {t("language_spanish")}</option>
              <option value="nl">🇳🇱 {t("language_dutch")}</option>
              <option value="pt">🇵🇹 {t("language_portuguese")}</option>
            </select>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="landing-main">
        <div className="welcome-section">
          <h1 className="welcome-title">{t("bepro")}</h1>
          <p className="welcome-tagline">{t("bepro_tagline")}</p>
          <p className="welcome-subtitle">{t("bepro_subtitle")}</p>
        </div>

        {/* Login Card */}
        <div className="login-card">
          <div className="login-header">
            <h2>{t("welcome_back")}</h2>
            <p>{t("sign_in_description")}</p>
          </div>

          {/* Login Buttons */}
          <div className="login-buttons">
            <Link to={"/login"} className="login-btn primary-btn">
              <span className="btn-icon">📧</span>
              <span>{t("emaillogin")}</span>
            </Link>
          </div>

          {/* Footer */}
          <div className="landing-footer">
            <p>{t("footer_copyright")}</p>
            {brand.show_powered_by && (
              <p style={{ fontSize: "11px", color: "#ccc", marginTop: "6px" }}>
                Powered by Smart TT Platform
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
